/*
 * «Valmis linjatarkastukseen» -ilmoitus (235, T520; Toni 18.9.2026 «oikein» — minimikolmikko).
 *
 * Johdettu valmius (Luovutusvalmius, nippu) kertoo mitä järjestelmä tietää; ilmoitus kertoo kuka sanoi linjan olevan valmis ja
 * milloin. Yksi avoin per linja, peruutus merkitään (rivi jää). Ilmoittaa työnjohto, suunnittelu tai pääkäyttäjä — sama
 * roolijoukko kuin palvelimella (POST/DELETE /api/linjat/:id/valmiusilmoitus).
 */
import { useCallback, useEffect, useState } from "react";
import { api, ApiError } from "./api";
import { t, virheTeksti } from "./kieli";
import { naytaPvm } from "./pvm";

export function Valmiusilmoitus({ linjaId, saaIlmoittaa }: { linjaId: number; saaIlmoittaa: boolean }) {
  const [avoin, setAvoin] = useState<{ ilmoitettu: string; huomio: string | null; ilmoittaja: string | null } | null | undefined>(undefined);
  const [huomio, setHuomio] = useState("");
  const [virhe, setVirhe] = useState<string | null>(null);
  const lataa = useCallback(() => api.valmiusilmoitus(linjaId).then((r) => setAvoin(r.avoin)).catch(() => setAvoin(null)), [linjaId]);
  useEffect(() => { void lataa(); }, [lataa]);
  const teko = (f: () => Promise<unknown>) => { setVirhe(null); f().then(() => { setHuomio(""); return lataa(); })
    .catch((e) => setVirhe(e instanceof ApiError ? virheTeksti(e.virhe, e.message) : String(e))); };
  if (avoin === undefined) return null;
  return (
    <div className="valmiusilmoitus" data-valmiusilmoitus={avoin ? "avoin" : "ei"}>
      {avoin ? (
        <p>
          <strong>{t("vi.ilmoitettu")}</strong>{" "}
          <span data-valmiusilmoitus-ilmoitettu="">{naytaPvm(avoin.ilmoitettu.slice(0, 10))} {avoin.ilmoitettu.slice(11)}{avoin.ilmoittaja ? ` · ${avoin.ilmoittaja}` : ""}</span>
          {avoin.huomio && <span className="dim"> — {avoin.huomio}</span>}
          {saaIlmoittaa && <>{" "}<button type="button" className="nappi nappi--kevyt" data-valmiusilmoitus-peru=""
            onClick={() => teko(() => api.peruValmiusilmoitus(linjaId))}>{t("vi.peru")}</button></>}
        </p>
      ) : saaIlmoittaa ? (
        <div className="valmiusilmoitus__lomake">
          <input value={huomio} onChange={(e) => setHuomio(e.target.value)} maxLength={500} placeholder={t("vi.huomio")} />
          <button type="button" className="nappi nappi--paa" data-valmiusilmoitus-ilmoita=""
            onClick={() => teko(() => api.ilmoitaValmiiksi(linjaId, huomio.trim() || undefined))}>{t("vi.ilmoita")}</button>
        </div>
      ) : <p className="dim">{t("vi.ei_ilmoitettu")}</p>}
      {virhe && <p className="huom huom--vika" role="alert">{virhe}</p>}
    </div>
  );
}
